<template lang="pug">
  transition(name='modal')
    .rc-modal-mask
      .rc-modal-wrapper
        .rc-modal-container(:style="{ width }")
          slot
</template>

<script>
export default {
  created () {
    document.addEventListener('keydown', this.keydownHandler);
  },
  props: {
    width: {
      type: String,
      default: '40em',
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    keydownHandler(e) {
      if (e.key === 'Escape') {
        this.close();
      }
    },
  },
  destroyed() {
    document.removeEventListener('keydown', this.close);
  },
}
</script>

<style lang="scss" scoped>
  .rc-modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
  }

  .rc-modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }

  .rc-modal-container {
    margin: 0px auto;
    padding: 20px 20px;
    background-color: #EFEFEF;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
  }

  .rc-modal-enter {
    opacity: 0;
  }

  .rc-modal-leave-active {
    opacity: 0;
  }

  .rc-modal-enter .rc-modal-container,
  .rc-modal-leave-active .rc-modal-container {
    -webkit-transform: scale(.2);
    transform: scale(.2);
  }

  .rc-modal-enter-active {
    opacity: 1;
  }

  .rc-modal-leave {
    opacity: 1;
  }

  .rc-modal-enter-active .rc-modal-container,
  .rc-modal-leave .rc-modal-container {
    -webkit-transform: scale(5);
    transform: scale(5);
  }
</style>